module.exports = __webpack_public_path__ + "static/media/buffet-icon.7f73efcf.svg";